import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM10.577 17.5c0-.584.072-1.15.208-1.692h3.2a15.737 15.737 0 0 0 0 3.384h-3.2a6.936 6.936 0 0 1-.208-1.692Zm5.163 0c0-.568.035-1.133.103-1.692h3.314a13.906 13.906 0 0 1 0 3.384h-3.314a13.908 13.908 0 0 1-.103-1.692Zm3.062 3.538h-2.604c.296 1.124.732 2.21 1.302 3.231a13.897 13.897 0 0 0 1.302-3.23Zm.864 3.04a15.75 15.75 0 0 0 1.037-3.04h2.749a6.942 6.942 0 0 1-3.786 3.04Zm-1.838 2.185c.105.012.211.006.313-.017a8.77 8.77 0 0 0 0-17.492.925.925 0 0 0-.312-.017 8.922 8.922 0 0 0-.658 0 .925.925 0 0 0-.312.017 8.77 8.77 0 0 0 0 17.492c.102.023.207.03.312.017a8.966 8.966 0 0 0 .657 0ZM17.5 10.731a13.894 13.894 0 0 0-1.302 3.23h2.604a13.898 13.898 0 0 0-1.302-3.23Zm3.515 5.077h3.2c.136.541.208 1.108.208 1.692 0 .584-.072 1.15-.208 1.692h-3.2a15.74 15.74 0 0 0 0-3.384Zm-.312-1.846a15.75 15.75 0 0 0-1.037-3.04 6.943 6.943 0 0 1 3.786 3.04h-2.749Zm-9.155 7.076h2.749c.24 1.045.588 2.063 1.037 3.04a6.942 6.942 0 0 1-3.786-3.04Zm0-7.076a6.943 6.943 0 0 1 3.786-3.04 15.737 15.737 0 0 0-1.037 3.04h-2.749Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgWeb;